__turbopack_context__.v({
  "logo": "ie-7oa_logo",
});
